<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
            b-container.d-flex.justify-content-between(fluid)
              div
                span.page-title {{$t('function-settings03')}} {{$t('history')}}
                b-button(variant="link", size="sm", style="padding: 0.25rem 0.7rem;", target="_blank", href="https://linkmemine.co.kr/faq/p/manager_guide_topic_07.php")
                  //icon(name="bookmark", style="margin:0 4px 0 2px;")
                  span {{$t('tutorial-statistics')}}
          b-container(fluid)
            b-row
              b-card.w-100(no-body)
                b-container(slot="header", fluid)
                  b-row.align-items-center
                    b-col(cols="2")
                      datepicker(
                        :value="range.start",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        @selected="startDateChanged")
                    b-col(cols="2")
                      datepicker(
                        :value="range.end",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        :disabledDates="range.disabledDates",
                        @selected="endDateChanged")
                    b-col(cols="2")
                      b-form-select(v-model="filter.key", :options="filter.options", size="sm", @change="keyChangeHandler")
                    b-col(cols="2")
                      b-form-input(v-model="filter.value", size="sm", @keydown.enter="tableRefresh")
                    b-col.d-flex(cols="2")
                      b-button(size="sm", @click="tableRefresh") {{$t('search')}}
                b-table(
                  ref="dataTable",
                  :fields="fields",
                  :items="items",
                  :current-page="page.current",
                  :per-page="page.per",
                  :show-empty="true",
                  tbody-class="lmm-table-body",
                  :empty-text="$t('no-content')")
                  template(slot="HEAD_start_time", slot-scope="data")
                    | {{$t('start_time')}}
                  template(slot="HEAD_end_time", slot-scope="data")
                    | {{$t('end_time')}}
                  template(slot="HEAD_mgrid", slot-scope="data")
                    | {{$t('ID')}}
                  template(slot="HEAD_file_name", slot-scope="data")
                    | {{$t('file_name')}}
                  template(slot="HEAD_action", slot-scope="data")
                    | {{$t('execute')}}
                  template(slot="HEAD_file_size", slot-scope="data")
                    | {{$t('size')}}
                  template(v-slot:cell(start_time)="row")
                    //- | {{row.item.start_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
                    | {{row.item.start_time | moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(end_time)="row")
                    //- | {{row.item.end_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
                    | {{row.item.end_time| moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(action_type)="row")
                    span(v-if="row.item.action_type === 1") {{$t('user')}} &gt; {{$t('device')}}
                    span(v-else) {{$t('device')}} &gt; {{$t('user')}}
                  template(v-slot:cell(device_os)="row")
                    icon(:name="getOS(row.item.device_os_id)")
                  template(v-slot:cell(file_size)="row")
                    | {{row.item.file_size | convBitSize}}
                div.d-flex.justify-content-between(slot="footer")
                  div
                    b-form-select(
                      size="sm",
                      v-model="page.per",
                      :options="page.perOptions")
                  b-pagination(
                    size="sm",
                    :total-rows="page.total",
                    :per-page="page.per",
                    v-model="page.current",
                    class="my-0 float-right"
                  )
</template>

<script>
import _ from "lodash"
import moment from "moment"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"
import { AnalysticAPI } from "../../api"

export default {
  name: "log-transfer-component",
  components: { Datepicker },
  methods: {
    keyChangeHandler() {
      this.filter.value = ""
    },
    startDateChanged(date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged(date) {
      this.range.end = date
    },
    tableRefresh() {
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },
    getOS(id) {
      switch (id) {
        case 1:
          return "windows"
        default:
          return "windows"
      }
    },
    items(ctx) {
      let params = {
        by: "create_time",
        start_date: moment(this.range.start).format("YYYY-MM-DD"),
        end_date: moment(this.range.end).format("YYYY-MM-DD"),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: "desc",
      }
      if (this.filter.value) {
        params.search_key = this.filter.key
        params.search_value = this.filter.value
      }
      return AnalysticAPI.history.get("file", { params }).then(resp => {
        this.page.total = resp.data.meta.total_count
        return resp.data.objects
      })
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      range: {
        start: new Date().setDate(-1),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      fields: [
        { key: "start_time", label: this.$t("start_time") },
        { key: "end_time", label: this.$t("end_time") },
        { key: "mgrid", label: this.$t("ID") },
        { key: "file_name", label: this.$t("file_name") },
        { key: "action_type", label: this.$t("execute") },
        { key: "file_size", label: this.$t("size") },
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
      filter: {
        key: "mgrid",
        value: "",
        options: [
          { text: this.$t("ID"), value: "mgrid" },
          { text: this.$t("file_name"), value: "fh_file_name" },
        ],
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row,
.col,
.container-fluid,
.container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

::v-deep .b-table {
  margin: 0;
  tr,
  td,
  th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1),
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(4),
  th:nth-child(5) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
  }
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6f6f6f;
  }
}

::v-deep .form-control,
.custom-select {
  display: flex;
  background-color: #ffffff !important;
  border: 1px solid #6f6f6f !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}
</style>
